"use strict";

exports.__esModule = true;
exports.validateMessageFilter = exports.validateConditionsNumber = void 0;
var _vimanaTypes = require("@vimana/vimana-types");
var validateConditionsNumber = exports.validateConditionsNumber = function validateConditionsNumber(conditions) {
  return conditions.length > 0;
};
var validateMessageFilter = exports.validateMessageFilter = function validateMessageFilter(condition) {
  var _condition$message, _condition$message2;
  return !!((_condition$message = condition.message) != null && _condition$message.nativeCode) || !!((_condition$message2 = condition.message) != null && _condition$message2.conditionText);
};